import { lazy } from "react";

export const AccountSettingsPage = lazy(() => import("pages/AccountSettingsPage/AccountSettingsPage"));
export const AnalyticsPage = lazy(() => import("pages/AnalyticsPage/AnalyticsPage"));
export const CategoriesPage = lazy(() => import("pages/CategoriesPage/CategoriesPage"));
export const CollectionItemsPage = lazy(() => import("pages/CollectionItemsPage/CollectionItemsPage"));
export const CollectionsPage = lazy(() => import("pages/CollectionsPage/CollectionsPage"));
export const CrashPage = lazy(() => import("pages/CrashPage/CrashPage"));
export const EmbedPage = lazy(() => import("pages/EmbedPage/EmbedPage"));
export const ExploreCreatorsPage = lazy(() => import("pages/ExploreCreatorsPage/ExploreCreatorsPage"));
export const ExploreGifsPage = lazy(() => import("pages/ExploreGifsPage/ExploreGifsPage"));
export const ExploreImagesPage = lazy(() => import("pages/ExploreImagesPage/ExploreImagesPage"));
export const ExploreNichesPage = lazy(() => import("pages/ExploreNichesPage/ExploreNichesPage"));
export const ExplorePage = lazy(() => import("pages/ExplorePage/ExplorePage"));
export const FavouritesPage = lazy(() => import("pages/FavouritesPage/FavouritesPage"));
export const FollowersPage = lazy(() => import("pages/subscriptions/FollowersPage"));
export const FollowingPage = lazy(() => import("pages/subscriptions/FollowingPage"));
export const HomePage = lazy(() => import("pages/HomePage/HomePage"));
export const ManagePage = lazy(() => import("pages/ManagePage"));
export const MigrateImgurPage = lazy(() => import("pages/Migrate/MigrateImgurPage"));
export const MigrateImgurConfirmPage = lazy(() => import("pages/Migrate/MigrateImgurConfirmPage"));
export const MigrateImgurSuccessPage = lazy(() => import("pages/Migrate/MigrateImgurSuccessPage"));
export const MyNichesPage = lazy(() => import("pages/MyNichesPage/MyNichesPage"));
export const NichePage = lazy(() => import("pages/NichePage/NichePage"));
export const PrivacyPolicyPage = lazy(() => import("pages/staticPages/PrivacyPolicyPage"));
export const ProfileSettingsPage = lazy(() => import("pages/ProfileSettingsPage/ProfileSettingsPage"));
export const Statement2257Page = lazy(() => import("pages/staticPages/Statement2257Page"));
export const SudoPage = lazy(() => import("pages/SudoPage/SudoPage"));
export const TagPage = lazy(() => import("pages/TagPage/TagPage"));
export const LoginPage = lazy(() => import("pages/LoginPage/LoginPage"));
export const VerifyPage = lazy(() => import("pages/VerifyPage/VerifyPage"));
export const TermsPage = lazy(() => import("pages/staticPages/TermsPage"));
export const GuidelinesPage = lazy(() => import("pages/staticPages/GuidelinesPage"));
export const FAQPage = lazy(() => import("pages/staticPages/FAQPage"));
export const DMCAPage = lazy(() => import("pages/staticPages/DMCAPage"));
export const UnsubscribedPage = lazy(() => import("pages/UnsubscribedPage/UnsubscribedPage"));
export const UploadPage = lazy(() => import("pages/UploadPage/UploadPage"));
export const UserPage = lazy(() => import("pages/UserPage/UserPage"));
export const WatchPage = lazy(() => import("pages/WatchPage/WatchPage"));
export const AuthorizePage = lazy(() => import("pages/AuthorizePage/AuthorizePage"));
export const ExperimentsPage = lazy(() => import("pages/ExperimentsPage/ExperimentsPage"));
